import { createFileRoute } from "@tanstack/react-router";
import type {} from "@tanstack/react-start";
import { GonePage, goneHandler } from "@/lib/seo/gone";

// Retired: pSEO gold showcase slugs. These duplicated the real hub and
// city pages (/pakistan, /india, /city/{country}/{city}, /gold-rate-{city}),
// which remain fully live.
export const Route = createFileRoute("/gold/$")({
  server: { handlers: { GET: goneHandler } },
  component: GonePage,
});
